/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

(function () {
    "use strict";

    angular
        .module("ROGER")

        //
        .controller("InvoicesController", [
            "$scope", "$http", "$sessionStorage", "$uibModal", "$well", "FileSaver", "Blob", "$oidc", "$translate", "$notifications",
            function ($scope, $http, $sessionStorage, $uibModal, $well, FileSaver, Blob, oidc, translate, notifications) {

                $scope.$storage = $sessionStorage;

                $scope.$storage.invoices = {
                    searchText: null,
                    dateFrom: null,
                    dateTo: null,
                    showProcessed: false,
                    showNotApproved: false
                }

                $scope.list = [];

                $scope.search = function () {
                    return $http
                        .get("/api/invoice/search", {
                            params: {
                                RetailerId: $scope.$storage.retailer.Id,
                                SearchText: $scope.$storage.invoices.searchText,
                                DateFrom: $scope.$storage.invoices.dateFrom,
                                DateTo: $scope.$storage.invoices.dateTo,
                                ShowProcessed: $scope.$storage.invoices.showProcessed,
                                ShowNotApproved: $scope.$storage.invoices.showNotApproved
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            $scope.list = response.data;
                        });
                };

                $scope.$watch("$storage.retailer", function (newValue, oldValue) {
                    if (oldValue.Id !== newValue.Id && newValue.Id > 0) {
                        $scope.search();
                    }
                });

                // Date pickers
                $scope.dateFromOpen = function ($event) {
                    $event.preventDefault();
                    $event.stopPropagation();

                    $scope.dateFromOpened = true;
                };

                $scope.dateToOpen = function ($event) {
                    $event.preventDefault();
                    $event.stopPropagation();

                    $scope.dateToOpened = true;
                };

                // Sorting
                $scope.sorting = function (orderName) {
                    if ($scope.$storage.invoices.orderName === orderName) {
                        $scope.$storage.invoices.orderDesc = !$scope.$storage.invoices.orderDesc;
                    } else {
                        $scope.$storage.invoices.orderName = orderName;
                        $scope.$storage.invoices.orderDesc = false;
                    }
                };

                $scope.sortingClass = function (orderName) {
                    if ($scope.$storage.invoices.orderName === orderName) {
                        if ($scope.$storage.invoices.orderDesc) {
                            return "fa fa-caret-down";
                        } else {
                            return "fa fa-caret-up";
                        }
                    } else {
                        return "";
                    }
                };

                // Customer
                $scope.getCustomerUrl = function (item) {
                    if (item.CustomerWellId) {
                        return $well.getPartyUrl(item.CustomerWellId);
                    } else {
                        return null;
                    }
                };

                $scope.getEndCustomerUrl = function (item) {
                    if (item.EndCustomerWellId) {
                        return $well.getPartyUrl(item.EndCustomerWellId);
                    } else {
                        return null;
                    }
                };

                // Processed
                $scope.setProcessed = function (invoice) {
                    return $http
                        .put("/api/invoice/" + invoice.Id + "/processed", {}, {
                            params: {
                                value: invoice.IsProcessed
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        });
                };

                // load financing and open financing modal
                $scope.openFinancing = function (invoice) {
                    return $http
                        .get("/api/financing/get/" + $scope.$storage.retailer.Id + "/" + invoice.FinancingId, {
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            $scope.openFinancingModal(response.data);
                        });
                };

                // create new financing and open financing modal
                $scope.createFinancing = function (invoice) {
                    return $http
                        .get("/api/financing/getnew/" + $scope.$storage.retailer.Id + "/" + invoice.Id, {
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            $scope.openFinancingModal(response.data);
                        });
                };

                // open financing modal
                $scope.openFinancingModal = function (financing) {
                    return $uibModal.open({
                        template: require("../Finance/Financing.html"),
                        controller: "FinancingController",
                        windowClass: "modal-window-large",
                        resolve: {
                            financing: function () {
                                return financing;
                            }
                        }
                    })
                        .result
                        .then(function () {
                            $scope.search();
                        }, function () { });
                };

                // open set deliver after modal
                $scope.setDeliverAfter = function (invoice) {
                    return $uibModal.open({
                        template: require("./InvoicesSetDeliverAfter.html"),
                        controller: "InvoicesSetDeliverAfterController",
                        resolve: {
                            invoice: function () {
                                return invoice;
                            }
                        }
                    })
                        .result
                        .then(function () {
                            $scope.search();
                        }, function () { });
                };

                $scope.downloadFile = function (id) {
                    _downloadFile(id);
                }

                function _downloadFile(id) {
                    return $http.get("/api/invoice/" + id + "/download", {
                        responseType: 'arraybuffer',
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        },
                        skipInterceptors: true
                    })
                        .then(function (response) {
                            var contentDisposition = response.headers("content-disposition");
                            var regex = /filename="*([^"].+[^"])"*;/g;
                            var result = regex.exec(contentDisposition);
                            var fileName = result[1];
                            var data = new Blob([response.data], { type: response.headers("content-type") });
                            FileSaver.saveAs(data, fileName);
                        }, function (data) {
                            translate(['InvoiceAttachmentDownloadError.Message', 'InvoiceAttachmentDownloadError.Name'])
                                .then(function (translations) {
                                    notifications.addError(
                                        translations['InvoiceAttachmentDownloadError.Name'],
                                        translations['InvoiceAttachmentDownloadError.Message']
                                    );
                                }, function () {
                                    notifications.addError(
                                        'Error',
                                        'An error occured when downloading attachments'
                                    );
                                })
                        });
                }

                if ($scope.$storage.retailer !== null && $scope.$storage.retailer.Id > 0) {
                    $scope.search();
                }
            }
        ]);
})();
